import { useMemo } from 'react'
import GuideMapPopup from './GuideMapPopup'
import Map from './Map'
import { setSelectedPin } from '../../../actions/dive-guide-actions'
import { connect } from 'react-redux'
import '../styles/map-container.scss'
import { MapContainer } from 'react-leaflet'
import { isMainLand } from '../../../config'
import { isMobile } from '../../../utils'
import useMapInitialBounds from '../../../hooks/useMapInitialBounds'

const isMobileDevice = isMobile()
const DiveSiteMap = ({
  pins,
  dsPoint,
  locationBounds,
  setSelectedPin,
  selectedPin,
  countryCode,
}) => {
  const points = useMemo(() => {
    return [...pins, ...dsPoint]
  }, [pins, dsPoint])
  const { initBounds } = useMapInitialBounds(locationBounds, points)
  const handlePinClick = (pin) => {
    setSelectedPin(pin)
  }
  const closePopup = () => {
    setSelectedPin(null)
  }
  return (
    <div className='map-with-popup'>
      {selectedPin && (
        <GuideMapPopup
          info={selectedPin}
          isDiveShop={selectedPin.pinType !== 'diveSite'}
          handleCloseClick={closePopup}
          hideViewDetails={selectedPin.pinType === 'diveSite'}
        />
      )}
      <MapContainer
        maxZoom={18}
        minZoom={isMainLand(countryCode) ? 2 : 1}
        zoomControl={false}
        scrollWheelZoom={false}
        tap={!isMobileDevice}
        touchZoom={isMobileDevice}
        dragging={!isMobileDevice}
        bounds={initBounds}
        zoom={14}
        style={{ height: '100%', minHeight: '70vh' }}
      >
        <Map
          bounds={initBounds}
          pins={points}
          onPinClick={handlePinClick}
          selectedPin={selectedPin}
          preventCentering
          allowClusteringDisable
          locationBounds={locationBounds}
          pinType='diveShop'
          countryCode={countryCode}
        />
      </MapContainer>
    </div>
  )
}

const mapStateToProps = (state) => ({
  selectedPin: state.selectedPin,
})

export default connect(mapStateToProps, { setSelectedPin })(DiveSiteMap)
